
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'; 


const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    root:{
      marginTop:70
  },
    paper: {
      maxWidth: 300,
      align:'center',
      margin:'3%',
      backgroundColor: '#C1E5DD',
      flex: 1,
      maxHeight: 300
  
    },
    text: {
        padding:'2%',
        paddingBottom:'1%',
    },
    item:
    {
        width:'33%'
    }
  }));

  export default (props) =>
        {   
    const classes = useStyles();
    

  
    
    
      return(
        <Grid justify="center" item className={classes.item}>
            <Paper className={classes.paper} > 
                <Typography className={classes.text}>
                     <span style={{fontWeight:'bold'}}>  {props.fullName} </span><br/>
                    {props.period}<br/>
                    {props.position}<br/>
                    {props.after}
                </Typography>
            </Paper>
         </Grid>);
  }
